export function Logo({ className = "h-12" }: { className?: string }) {
  return (
    <img 
      src="/logo.png" 
      alt="شجرة العائلة"
      className={className}
    />
  );
}